import { render, staticRenderFns } from "./ModuloDeLaboratorio.vue?vue&type=template&id=3fd4a6b6&"
import script from "./ModuloDeLaboratorio.vue?vue&type=script&lang=js&"
export * from "./ModuloDeLaboratorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports